import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';

import { getExternalSession } from '@/utils/session/get-external-session';

/**
 * Guards one study's external pages with that project's external session.
 *
 * The session's account is put in context for loaders that call core-api
 * from the server. In the browser, the API client adds the project header on
 * these pages (see `utils/client-init.ts`), and the proxy answers as this
 * session rather than the participant app's.
 */
export const Route = createFileRoute(
  '/participants/_external/external/projects/$projectId',
)({
  beforeLoad: async ({ params }) => {
    const session = await getExternalSession({
      data: { projectId: params.projectId },
    });

    if (!session) {
      // No session for this study on this browser: nothing here for them.
      throw redirect({ to: '/participants/invite/only' });
    }

    return { externalUserId: session.userId };
  },
  component: Outlet,
});
